import { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useForm } from 'react-hook-form'
import useLicensesHook from '../../../api/licenses'
import {
  Message,
} from '../../../components'
import FormLicenses from '../../../components/licenses/FormLicenses'
import ViewLicenses from '../../../components/licenses/ViewLicenses'

const Licenses = () => {
  const [id, setId] = useState(null)
  const [edit, setEdit] = useState(false)


  const { getLicenses, postLicense, updateLicense } =
    useLicensesHook({
      page:1
    })

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      auth: true,
    },
  })

  const { data, isLoading, isError, error } = getLicenses

  const {
    isLoading: isLoadingUpdate,
    isError: isErrorUpdate,
    error: errorUpdate,
    isSuccess: isSuccessUpdate,
    mutateAsync: mutateAsyncUpdate,
  } = updateLicense


  const {
    isLoading: isLoadingPost,
    isError: isErrorPost,
    error: errorPost,
    isSuccess: isSuccessPost,
    mutateAsync: mutateAsyncPost,
  } = postLicense

  const formCleanHandler = () => {
    setEdit(false)
    reset()
  }

  useEffect(() => {
    if (isSuccessPost || isSuccessUpdate) formCleanHandler()
  }, [isSuccessPost, isSuccessUpdate])



  const submitHandler = (data) => {
    edit
      ? mutateAsyncUpdate({
          _id: id,
          name: data.name,
          type: data.type,
          active: data.active,
        })
      : mutateAsyncPost(data)
  }

  const editHandler = (license) => {
    setId(license._id)
    setEdit(true)
    setValue('name', license.name)
    setValue('type', license.type)
    setValue('active', license.active)
  }

  return (
    <>
      <Helmet>
        <title>Licencias</title>
        <meta property='og:title' content='Licencias' key='title' />
      </Helmet>
      {isSuccessUpdate && (
        <Message variant='success'>
         La Licencia se ha actualizado correctamente.
        </Message>
      )}
      {isErrorUpdate && <Message variant='danger'>{errorUpdate}</Message>}
      {isSuccessPost && (
        <Message variant='success'>
          La Licencia se ha creado correctamente.
        </Message>
      )}
      {isErrorPost && <Message variant='danger'>{errorPost}</Message>}

      <FormLicenses
        edit={edit}
        id={id}
        formCleanHandler={formCleanHandler}
        isLoading={isLoading}
        isError={isError}
        errors={errors}
        isLoadingUpdate={isLoadingUpdate}
        isLoadingPost={isLoadingPost}
        register={register}
        handleSubmit={handleSubmit}
        submitHandler={submitHandler}
        watch={watch}
        error={error}
      />

     

   
        <ViewLicenses
          data={data}
          editHandler={editHandler}
        />
      
    </>
  )
}

export default Licenses
